import { Col, Row } from "antd";
import { t } from "i18next";
import React from "react";

import {
  DetaljiOSkladistu,
  DetaljiZahtevaDozvole,
} from "../../../../modules/ministry/ministry.types";
import { DozvolaTipObjekta } from "../../../../modules/obligee/exciseLicences/exciseLicences.types";
import { AkciznaMarkicaKategorijaProzivoda } from "../../../../modules/obligee/exciseStamps/exciseStamps.types";
import style from "./Info.module.scss";

interface IInfoProps {
  data?: DetaljiZahtevaDozvole;
  dataSkladista?: DetaljiOSkladistu;
  type?: boolean;
}
//if type true => type is dozvole

export const Info: React.FC<IInfoProps> = ({ data, dataSkladista, type }) => {
  const checkIsProductOfType = (
    productType: AkciznaMarkicaKategorijaProzivoda
  ) => {
    return (
      data?.dozvolaInformacije?.kategorijaProizvodaId === productType ||
      dataSkladista?.kategorijaProizvodaId === productType
    );
  };

  const getTipObjekta = (tipObjekta?: DozvolaTipObjekta | null) => {
    if (!tipObjekta) return "";

    switch (tipObjekta) {
      case DozvolaTipObjekta.SKLADISTE:
        return t("SETTINGS_OBJECTS.AKCIZNO_SKLADISTE");
      case DozvolaTipObjekta.PROIZVODNJA_SA_SKLADISTEM:
        return t("AKCIZNE_DOZVOLE.AKCIZNO_SKLADISTE_PROIZVODNI_POGON");
      default:
        return "";
    }
  };

  return (
    <Col className={style.mainContainer} span={24}>
      <Row>
        <Col span={12}>
          <Col className="textBold pb-20" span={24}>
            <span className={style.fontSize}>
              {t("AKCIZNE_DOZVOLE.TIP_OBJEKTA")}:
            </span>
          </Col>
          <Row className={style.row}>
            <Col span={12}>
              <span className={style.fontSize}>
                {getTipObjekta(data?.tipDozvole || dataSkladista?.tipDozvole)}
              </span>
            </Col>
          </Row>
          <Col className="textBold pb-20 pt-20" span={24}>
            <span className={style.fontSize}>
              {t(
                "AKCIZNE_DOZVOLE.VRSTA_AKCIZNOG_PROIZVODA_KOJI_CE_SE_PROIZVODITI_I_SMESTATI_U_SKLADISTE"
              )}
              :
            </span>
          </Col>
          <Row className={style.row}>
            <Col span={12}>
              <span className={style.fontSize}>
                {type
                  ? data?.odabranaKategorijaProizvoda
                  : dataSkladista?.vrstaAkciznogProizvoda}
              </span>
            </Col>
          </Row>
          <Col className="textBold pb-20 pt-20" span={24}>
            <span className={style.fontSize}>
              {t(
                "AKCIZNE_DOZVOLE.ADRESA_GDE_SE_OBAVLJA_PROIZVODNJA_AKCIZNOG_PROIZVODA"
              )}
              :
            </span>
          </Col>
          <Row className={style.row}>
            <Col span={14}>
              <span className={style.fontSize}>
                {t("AKCIZNE_DOZVOLE.ULICA_I_BROJ")}:
              </span>
            </Col>
            <Col span={10}>
              <span className={style.fontSize}>
                {type
                  ? `${data?.dozvolaInformacije?.ulicaProizvodnje} - ${data?.dozvolaInformacije?.brojUliceProizvodnje}`
                  : dataSkladista?.adresaProizvodnje.ulicaIBrojProizvodnje}
              </span>
            </Col>
          </Row>
          <Row className={style.row}>
            <Col span={14}>
              <span className={style.fontSize}>
                {t("AKCIZNE_DOZVOLE.POSTANSKI_BROJ")}:
              </span>
            </Col>
            <Col span={10}>
              <span className={style.fontSize}>
                {type
                  ? data?.dozvolaInformacije.postanskiBrojProizvodnje
                  : dataSkladista?.adresaProizvodnje.postanskiBrojProizvodnje}
              </span>
            </Col>
          </Row>
          <Row className={style.row}>
            <Col span={14}>
              <span className={style.fontSize}>
                {t("AKCIZNE_DOZVOLE.MESTO")}:
              </span>
            </Col>
            <Col span={10}>
              <span className={style.fontSize}>
                {type
                  ? data?.dozvolaInformacije.mestoProizvodnje
                  : dataSkladista?.adresaProizvodnje.mestoProizvodnje}
              </span>
            </Col>
          </Row>
          <Col className="textBold pb-20 pt-20" span={24}>
            <span className={style.fontSize}>
              {t("AKCIZNE_DOZVOLE.OSTALE_INFORMACIJE")}:
            </span>
          </Col>
          {type ? (
            data?.dozvolaInformacije?.kategorijaProizvodaId ===
            AkciznaMarkicaKategorijaProzivoda.DUVAN ? (
              <>
                <Row className={style.row}>
                  <Col span={16}>
                    <span className={style.fontSize}>
                      {t("AKCIZNE_DOZVOLE.KOLICINA_DUVANA_U_KG")}:
                    </span>
                  </Col>
                  <Col span={8}>
                    <span className={style.fontSize}>
                      {data?.dozvolaInformacije.kolicinaDuvanaKg ?? "/"}
                    </span>
                  </Col>
                </Row>
                <Row className={style.row}>
                  <Col span={16}>
                    <span className={style.fontSize}>
                      {t(
                        "AKCIZNE_DOZVOLE.KOLICINA_POJEDINACNIH_PAKOVANJA_U_KOMADIMA"
                      )}
                      :
                    </span>
                  </Col>
                  <Col span={8}>
                    <span className={style.fontSize}>
                      {data?.dozvolaInformacije
                        .kolicinaPojedinacnihPakovanjaKomadi ?? "/"}
                    </span>
                  </Col>
                </Row>
                <Row className={style.row}>
                  <Col span={16}>
                    <span className={style.fontSize}>
                      {t("AKCIZNE_DOZVOLE.PROSECNA_KOLICINA_DUVANA_U_KG")}:
                    </span>
                  </Col>
                  <Col span={8}>
                    <span className={style.fontSize}>
                      {data?.dozvolaInformacije.prosecnaKolicinaDuvanaKg ?? "/"}
                    </span>
                  </Col>
                </Row>
                <Row className={style.row}>
                  <Col span={16}>
                    <span className={style.fontSize}>
                      {t(
                        "AKCIZNE_DOZVOLE.PROSECNA_KOLICINA_POJEDINACNIH_PAKOVANJA_U_KOMADIMA"
                      )}
                      :
                    </span>
                  </Col>
                  <Col span={8}>
                    <span className={style.fontSize}>
                      {data?.dozvolaInformacije
                        .prosecnaKolicinaPojedinacnihPakovanjaKomadi ?? "/"}
                    </span>
                  </Col>
                </Row>
              </>
            ) : (
              <Row className={style.row}>
                <Col span={16}>
                  <span className={style.fontSize}>
                    {t(
                      "AKCIZNE_DOZVOLE.KOLICINA_USKLADISTENIH_PROIZVODA_NA_ZALIHAMA_U_PROSTORU"
                    )}
                    :
                  </span>
                </Col>
                <Col span={8}>
                  <span className={style.fontSize}>
                    {data?.dozvolaInformacije.kolicinaUskladistenihProizvoda ??
                      "/"}
                  </span>
                </Col>
              </Row>
            )
          ) : dataSkladista?.kategorijaProizvodaId ===
            AkciznaMarkicaKategorijaProzivoda.DUVAN ? (
            <>
              <Row className={style.row}>
                <Col span={16}>
                  <span className={style.fontSize}>
                    {t("AKCIZNE_DOZVOLE.KOLICINA_DUVANA_U_KG")}:
                  </span>
                </Col>
                <Col span={8}>
                  <span className={style.fontSize}>
                    {dataSkladista?.kolicinaDuvanaKg}
                  </span>
                </Col>
              </Row>
              <Row className={style.row}>
                <Col span={16}>
                  <span className={style.fontSize}>
                    {t(
                      "AKCIZNE_DOZVOLE.KOLICINA_POJEDINACNIH_PAKOVANJA_U_KOMADIMA"
                    )}
                    :
                  </span>
                </Col>
                <Col span={8}>
                  <span className={style.fontSize}>
                    {dataSkladista?.kolicinaPojedinacnihPakovanjaKomadi ?? "/"}
                  </span>
                </Col>
              </Row>
              <Row className={style.row}>
                <Col span={16}>
                  <span className={style.fontSize}>
                    {t("AKCIZNE_DOZVOLE.PROSECNA_KOLICINA_DUVANA_U_KG")}:
                  </span>
                </Col>
                <Col span={8}>
                  <span className={style.fontSize}>
                    {dataSkladista.prosecanMesecniRashodDuvanaKg ?? "/"}
                  </span>
                </Col>
              </Row>
              <Row className={style.row}>
                <Col span={16}>
                  <span className={style.fontSize}>
                    {t(
                      "AKCIZNE_DOZVOLE.PROSECNA_KOLICINA_POJEDINACNIH_PAKOVANJA_U_KOMADIMA"
                    )}
                    :
                  </span>
                </Col>
                <Col span={8}>
                  <span className={style.fontSize}>
                    {dataSkladista.prosecanMesecniRashodDuvanaKomadi ?? "/"}
                  </span>
                </Col>
              </Row>
            </>
          ) : (
            <Row className={style.row}>
              <Col span={16}>
                <span className={style.fontSize}>
                  {t(
                    "AKCIZNE_DOZVOLE.KOLICINA_USKLADISTENIH_PROIZVODA_NA_ZALIHAMA_U_PROSTORU"
                  )}
                  :
                </span>
              </Col>
              <Col span={8}>
                <span className={style.fontSize}>
                  {dataSkladista?.kolicinaUskladistenihProizvoda ?? "/"}
                </span>
              </Col>
            </Row>
          )}

          {checkIsProductOfType(AkciznaMarkicaKategorijaProzivoda.DUVAN) ? (
            <> </>
          ) : (
            <Row className={style.row}>
              <Col span={16}>
                <span className={style.fontSize}>
                  {t("AKCIZNE_DOZVOLE.PROSECAN_MESECNI_RASHOD")}:
                </span>
              </Col>
              <Col span={8}>
                <span className={style.fontSize}>
                  {type
                    ? data?.dozvolaInformacije.prosecanMesecniRashod
                    : dataSkladista?.prosecanMesecniRashod ?? "/"}
                </span>
              </Col>
            </Row>
          )}

          <Row className={style.row}>
            <Col span={16}>
              <span className={style.fontSize}>
                {t("AKCIZNE_DOZVOLE.NACIN_OTPREMANJA_AKCIZNIH_PROIZVODA")}:
              </span>
            </Col>
            <Col span={8}>
              <span className={style.fontSize}>
                {type
                  ? data?.dozvolaInformacije.nacinOtpremanja
                  : dataSkladista?.nacinOtpremanja}
              </span>
            </Col>
          </Row>
          <Row className={style.row}>
            <Col span={16}>
              <span className={style.fontSize}>
                {t("AKCIZNE_DOZVOLE.PODATAK_O_MERNIM_UREDJAJIMA")}:
              </span>
            </Col>
            <Col span={8}>
              <span className={style.fontSize}>
                {type
                  ? data?.dozvolaInformacije.podatakOMernimUredjajima
                  : dataSkladista?.podatakOMernimUredjajima}
              </span>
            </Col>
          </Row>
          {data?.dozvolaInformacije?.kategorijaProizvodaId ===
            AkciznaMarkicaKategorijaProzivoda.DERIVATI_NAFTE ||
          dataSkladista?.kategorijaProizvodaId ===
            AkciznaMarkicaKategorijaProzivoda.DERIVATI_NAFTE ? (
            <Row className={style.row}>
              <Col span={16}>
                <span className={style.fontSize}>
                  {t("AKCIZNE_DOZVOLE.TARIFNA_OZNAKA")}:
                </span>
              </Col>
              <Col span={8}>
                <span className={style.fontSize}>
                  {type
                    ? data?.dozvolaInformacije?.tarifnaOznaka
                    : dataSkladista?.tarfinaOznaka}
                </span>
              </Col>
            </Row>
          ) : (
            <></>
          )}
        </Col>
        <Col span={12}>
          <Col span={24} className="textBold pb-20">
            <span className={style.fontSize}>
              {t(
                "AKCIZNE_DOZVOLE.BROJ_I_DATUM_RESENJA_NADLEZNOG_ORGANA_U_POGLEDU_TEHNICKE_OPREMLJENOSTI"
              )}
              :
            </span>
          </Col>
          <Row className={style.row}>
            <Col span={10}>
              <span className={style.fontSize}>
                {type
                  ? data?.dozvolaInformacije.brojResenja
                  : dataSkladista?.brojResenja}
                /
                {type
                  ? data?.dozvolaInformacije.datumResenjaNadleznogOrganaPrikaz
                  : dataSkladista?.datumResenjaNadleznogOrgana}
              </span>
            </Col>
          </Row>
          <Col span={24} className="textBold pt-20 pb-20">
            <span className={style.fontSize}>
              {t("AKCIZNE_DOZVOLE.OSTALE_INFORMACIJE")}:
            </span>
          </Col>
          <Row className={style.row}>
            <Col span={14}>
              <span className={style.fontSize}>
                {checkIsProductOfType(AkciznaMarkicaKategorijaProzivoda.DUVAN)
                  ? `${t(
                      "AKCIZNE_DOZVOLE.OSTVARENA_KOLICINA_PROIZVEDENIH_AKCIZNIH_PROIZVODA_U_PROTEKLOJ_KALENDARSKOJ_GODINI_U"
                    )} kg`
                  : t(
                      "AKCIZNE_DOZVOLE.OSTVARENA_KOLICINA_PROIZVEDENIH_AKCIZNIH_PROIZVODA_U_PROTEKLOJ_KALENDARSKOJ_GODINI"
                    )}
                :
              </span>
            </Col>
            <Col span={8}>
              <span className={style.fontSize}>
                {type
                  ? checkIsProductOfType(
                      AkciznaMarkicaKategorijaProzivoda.DUVAN
                    )
                    ? data?.skladisteInformacije
                        ?.kolicinaProizvodaIzPrethodneGodineKg ?? "/"
                    : data?.skladisteInformacije
                        ?.kolicinaProizvodaIzPrethodneGodine ?? "/"
                  : checkIsProductOfType(
                      AkciznaMarkicaKategorijaProzivoda.DUVAN
                    )
                  ? dataSkladista?.kolicinaProizvodaIzPrethodneGodineDuvanaKg ??
                    "/"
                  : dataSkladista?.kolicinaProizvodaIzPrethodneGodine ?? "/"}
              </span>
            </Col>
          </Row>
          {checkIsProductOfType(AkciznaMarkicaKategorijaProzivoda.DUVAN) ? (
            <Row className={style.row}>
              <Col span={14}>
                <span className={style.fontSize}>
                  {t(
                    "AKCIZNE_DOZVOLE.OSTVARENA_KOLICINA_PROIZVEDENIH_AKCIZNIH_PROIZVODA_U_PROTEKLOJ_KALENDARSKOJ_GODINI_U_KOMADIMA"
                  )}
                  :
                </span>
              </Col>
              <Col span={8}>
                <span className={style.fontSize}>
                  {type
                    ? data?.skladisteInformacije
                        ?.kolicinaProizvodaIzPrethodneGodineKomadi ?? "/"
                    : dataSkladista?.kolicinaProizvodaIzPrethodneGodineDuvanaKomadi ??
                      "/"}
                </span>
              </Col>
            </Row>
          ) : (
            <></>
          )}
          <Row className={style.row}>
            <Col span={16}>
              <span className={style.fontSize}>
                {checkIsProductOfType(AkciznaMarkicaKategorijaProzivoda.DUVAN)
                  ? `${t(
                      "AKCIZNE_DOZVOLE.PLANIRANE_KOLICINE_GODISNJE_PROIZVODNJE_AKCIZNOG_PROIZVODA_U"
                    )} kg`
                  : t(
                      "AKCIZNE_DOZVOLE.PLANIRANE_KOLICINE_GODISNJE_PROIZVODNJE_AKCIZNOG_PROIZVODA"
                    )}
                :
              </span>
            </Col>
            <Col span={8}>
              <span className={style.fontSize}>
                {type
                  ? checkIsProductOfType(
                      AkciznaMarkicaKategorijaProzivoda.DUVAN
                    )
                    ? data?.skladisteInformacije
                        .planiranaProizvodnjaProizvodaKg ?? "/"
                    : data?.skladisteInformacije
                        .planiranaProizvodnjaProizvoda ?? "/"
                  : checkIsProductOfType(
                      AkciznaMarkicaKategorijaProzivoda.DUVAN
                    )
                  ? dataSkladista?.planiranaProizvodnjaProizvodaDuvanaKg ?? "/"
                  : dataSkladista?.planiranaProizvodnjaProizvoda ?? "/"}
              </span>
            </Col>
          </Row>
          {checkIsProductOfType(AkciznaMarkicaKategorijaProzivoda.DUVAN) ? (
            <Row className={style.row}>
              <Col span={16}>
                <span className={style.fontSize}>
                  {t(
                    "AKCIZNE_DOZVOLE.PLANIRANE_KOLICINE_GODISNJE_PROIZVODNJE_AKCIZNOG_PROIZVODA_U_KOMADIMA"
                  )}
                  :
                </span>
              </Col>
              <Col span={8}>
                <span className={style.fontSize}>
                  {type
                    ? data?.skladisteInformacije
                        ?.planiranaProizvodnjaProizvodaKomadi ?? "/"
                    : dataSkladista?.planiranaProizvodnjaProizvodaDuvanaKomadi ??
                      "/"}
                </span>
              </Col>
            </Row>
          ) : (
            <></>
          )}
          <Row className={style.row}>
            <Col span={16} className="textBold pb-20 pt-20">
              <span className={style.fontSize}>
                {t(
                  "AKCIZNE_DOZVOLE.BR_SKLADISTA_ZA_KOJE_TRAZI_AKCIZNU_DOZVOLU"
                )}
                :
              </span>
            </Col>
            <Col className="pt-20" span={8}>
              <span className={style.fontSize}>
                {type
                  ? data?.skladisteInformacije.brojSkladistaZaDozvolu
                  : dataSkladista?.brojSkladistaZaDozvolu}
              </span>
            </Col>
          </Row>
          <Row className={style.row}>
            <Col span={10}>
              <span className={style.fontSize}>
                {t("AKCIZNE_DOZVOLE.ULICA_I_BROJ")}:
              </span>
            </Col>
            <Col span={14}>
              <span className={style.fontSize}>
                {type
                  ? `${data?.skladisteInformacije.ulicaSkladista} - ${data?.skladisteInformacije.brojUliceSkladista}`
                  : dataSkladista?.adresaSkladista.ulicaIBrojSkladista}
              </span>
            </Col>
          </Row>
          <Row className={style.row}>
            <Col span={10}>
              <span className={style.fontSize}>
                {t("AKCIZNE_DOZVOLE.POSTANSKI_BROJ")}:
              </span>
            </Col>
            <Col span={14}>
              <span className={style.fontSize}>
                {type
                  ? data?.skladisteInformacije.postanskiBrojSkladista
                  : dataSkladista?.adresaSkladista.postanskiBrojSkladista}
              </span>
            </Col>
          </Row>
          <Row className={style.row}>
            <Col span={10}>
              <span className={style.fontSize}>
                {t("AKCIZNE_DOZVOLE.MESTO")}:
              </span>
            </Col>
            <Col span={14}>
              <span className={style.fontSize}>
                {type
                  ? data?.skladisteInformacije.mestoSkladista
                  : dataSkladista?.adresaSkladista.mestoSkladista}
              </span>
            </Col>
          </Row>
          <Row className={style.row}>
            <Col span={10}>
              <span className={style.fontSize}>
                {t("AKCIZNE_DOZVOLE.OZNAKA_SKLADISTA")}:
              </span>
            </Col>
            <Col span={14}>
              <span className={style.fontSize}>
                {type
                  ? data?.skladisteInformacije.oznakaSkladista
                  : dataSkladista?.oznakaSkladista}
              </span>
            </Col>
          </Row>
          <Row className={style.row}>
            <Col span={10}>
              <span className={style.fontSize}>{t("PLACEHOLDERS.MERA")}:</span>
            </Col>
            <Col span={14}>
              <span className={style.fontSize}>
                {type
                  ? data?.skladisteInformacije.meraTip
                  : dataSkladista?.meraTip}
              </span>
            </Col>
          </Row>
          <Row className={style.row}>
            <Col span={10}>
              <span className={style.fontSize}>
                {t("AKCIZNE_DOZVOLE.VREDNOST")}:
              </span>
            </Col>
            <Col span={14}>
              <span className={style.fontSize}>
                {type
                  ? data?.skladisteInformacije.meraVrednost
                  : dataSkladista?.meraVrednost}
              </span>
            </Col>
          </Row>
          <Col span={24} className="textBold pt-20 pb-20">
            <span className={style.fontSize}>
              {t("AKCIZNE_DOZVOLE.OPIS_AKCIZNOG_SKLADISTA")}:
            </span>
          </Col>
          <Row className={style.row}>
            <Col span={24}>
              <span className={style.fontSize}>
                {type
                  ? data?.skladisteInformacije.opisSkladista
                  : dataSkladista?.opisSkladista}
              </span>
            </Col>
          </Row>
          <Col span={24} className="textBold pt-20 pb-20">
            <span className={style.fontSize}>
              {t("AKCIZNE_DOZVOLE.OPIS_RADA_SISTEMA_RACUNOVODSTVA")}:
            </span>
          </Col>
          <Row className={style.row}>
            <Col span={24}>
              <span className={style.fontSize}>
                {type
                  ? data?.skladisteInformacije.opisRadaRacunovodstva
                  : dataSkladista?.opisRadaRacunovodstva}
              </span>
            </Col>
          </Row>
        </Col>
      </Row>
    </Col>
  );
};
